import { Misc } from "@/data/util/Misc";


function isEmptyAmount(amount: number, displayZeroAmount: boolean) {
    return isNaN(amount) || amount === null || amount === undefined || (!displayZeroAmount && amount === 0);
}

export function toMoney(
    amount: number,
    displayZeroAmount: boolean = false,
    locale: string = "en-CH",
    displayDecimals: boolean = true
) {
    if (isEmptyAmount(amount, displayZeroAmount)) {
        return "";
    }

    return Misc.roundCents(amount).toLocaleString(locale ?? "en-CH", {
        minimumFractionDigits: displayDecimals ? 2 : 0,
    });
}

// The price of a price per minute item: a rate with up to 5 decimals (28 CHF per hour is 0.46667), trailing zeros trimmed
// down to the 2 of a price. Not rounded to cents like toMoney - only the offer overviews show it, the cart shows prices rounded
export function toRate(amount: number, displayZeroAmount: boolean = false, locale: string = "en-CH") {
    if (isEmptyAmount(amount, displayZeroAmount)) {
        return "";
    }

    return amount.toLocaleString(locale ?? "en-CH", { minimumFractionDigits: 2, maximumFractionDigits: 5 });
}

// export function toMoneyWithSign(
//     amount: number,
//     displayZeroAmount: boolean = false,
//     locale: string = "en-CH",
//     displayDecimals: boolean = true
// ) {
//     if (isEmptyAmount(amount, displayZeroAmount)) {
//         return "";
//     }
//
//     return Misc.roundCents(amount).toLocaleString(locale ?? "en-CH", {
//         style: "currency",
//         currency: "CHF",
//         minimumFractionDigits: displayDecimals ? 2 : 0,
//     });
// }

export function toMoneyWithSign(
    amount: number,
    displayZeroAmount: boolean = false,
    locale: string = "en-CH",
    displayDecimals: boolean = true
) {

    if (isEmptyAmount(amount, displayZeroAmount)) {
        return "";
    }


    const formatter = new Intl.NumberFormat(locale ?? "en-CH", {
        style: "currency",
        currency: "CHF",
        minimumFractionDigits: displayDecimals ? 2 : 0,
    });

    const rounded = Misc.roundCents(amount);
    const parts = formatter.formatToParts(rounded);

    const amountWithCurrency = parts
        .map((part, i) => {
            // Insert a space between currency and a minus sign that directly follows it
            if (part.type === "currency" && parts[i + 1]?.type === "minusSign") {
                return part.value + " ";
            }
            return part.value;
        })
        .join("");

    return amountWithCurrency;
}

export function toFormattedNumber(price: number, locale: string = "en-CH", displayDecimals: boolean = false) {
    return Misc.roundCents(price).toLocaleString(locale ?? "en-CH", { minimumFractionDigits: displayDecimals ? 2 : 0 });
}
